export default class NewsArticle
{
    public nodeGUID: string = '';
    public title: string = '';
    public publicationDate: string = '';
    public linkText: string = '';
    public url: string = '';
    public html: string = '';
}